import { useAnimatedNumber } from '../utils/adminAnimations';
import { useCurrencySymbol } from '@/hooks/useCurrencySymbol';

export function AnimatedValue({ value, currency }: { value: number; currency?: boolean }) {
  const d = useAnimatedNumber(value);
  const sym = useCurrencySymbol();
  return <>{d.toLocaleString()}{currency ? ` ${sym}` : ''}</>;
}
